import { Button, Icon, Input } from "atm-global-stylish/dist";
import { useEffect, useState } from "react";
import { isEmpty, showModal } from "../../utils/functions";
import useSiniestrosStore from "../../store/siniestrosStore";
import { setSinisterTypeLocal, setToken } from "../../utils/claimManager";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../../components";
import { INPUT_CLASSNAME } from "../../config/constants";

export default function Testing() {
    const navigate = useNavigate();
    const { instance } = useParams();

    const { getInstance } = useSiniestrosStore();
    const [uuid, setUuid] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);

    useEffect(() => {
        if (!isEmpty(instance)) {
            setUuid(instance);
        } else {
            setLoadingPage(false);
        }
    }, [instance]);

    useEffect(() => {
        if (!isEmpty(instance) && !isEmpty(uuid)) {
            (async () => {
                await searchClaim();
            })();
        }
    }, [instance, uuid]);

    const searchClaim = async () => {
        if (!isEmpty(uuid)) {
            setLoading(true);

            const response = await getInstance(uuid);

            if (!isEmpty(response)) {
                const { step, things } = response;

                setToken(uuid.trim());

                if (!isEmpty(things))
                    setSinisterTypeLocal(things);
                else
                    showModal('', 'No se ha encontrado un things válido');

                if (!isEmpty(step))
                    navigate(`/stepper/${step}`);
                else
                    showModal('', 'No se ha encontrado un step válido (puede ser que sea step 0)');
            }

            setLoading(false);
        }
    }

    if (loadingPage) {
        return (
            <div className="h-[100vh] content-center">
                <Loader />
            </div>
        );
    }

    return (
        <div className="flex flex-col h-[100vh] p-10">
            <div className="flex flex-col w-2/4 self-center">
                <Input handleChange={(e) => { setUuid(e.target.value) }} value={uuid} className={INPUT_CLASSNAME} />
                <div className="w-2/4 self-center mt-6">
                    <Button type="primary" title="Buscar reclamo" className="py-2" handleClick={searchClaim} disabled={loading} icon={loading === true ? <Icon.Spinner color='white' size={20} className='ms-2 animate-spin' /> : <></>} />
                </div>
            </div>
        </div>
    );
}